import { StyleSheet, Text, View, ImageBackground, Button } from "react-native";
import React, { useEffect, useState, useContext } from "react";

import UserContext from "../store/user-data-context";
import { FontAwesome } from "@expo/vector-icons";
import LotteryGiftIcon from "../components/LotteryGiftIcon";

const User = ({ navigation }) => {
  const userCtx = useContext(UserContext);
  let selectWordArray = userCtx.selectWordList;

  function logouthandler() {
    localStorage.removeItem("fubon2022UserName");
    userCtx.setUserName("");
    userCtx.setSelectWordList([]);
    navigation.navigate("Login");
  }

  return (
    <View style={styles.container}>
      <View style={styles.iconAndName}>
        <FontAwesome name="user" size={25} color="#BA6612" />
        <Text style={styles.nameText}>{userCtx.userName}講師</Text>
      </View>
      <Text>您已經搜集了下方白底的集字：</Text>
      <View style={styles.badgeContainer}>
        <ImageBackground
          source={require("../assets/festival2022logo-tcc.png")}
          resizeMode="cover"
          style={styles.image}
        >
          <View style={styles.badgeRowContainer}>
            <LotteryGiftIcon
              iconName="尊"
              style={
                selectWordArray.includes("尊") && {
                  backgroundColor: "#FFFFFF47",
                }
              }
            />
            <LotteryGiftIcon
              iconName="師"
              style={
                selectWordArray.includes("師") && {
                  backgroundColor: "#FFFFFF47",
                }
              }
            />
          </View>
          <View style={styles.badgeRowContainer}>
            <LotteryGiftIcon
              iconName="慶"
              style={
                selectWordArray.includes("慶") && {
                  backgroundColor: "#FFFFFF47",
                }
              }
            />
            <LotteryGiftIcon
              iconName="典"
              style={
                selectWordArray.includes("典") && {
                  backgroundColor: "#FFFFFF47",
                }
              }
            />
          </View>
        </ImageBackground>
      </View>
      <Button
        onPress={logouthandler}
        title="重新登入"
        color="#554E06"
        accessibilityLabel="請確認是本人登入"
      />
    </View>
  );
};

export default User;

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#EFD7AC",
  },
  title: {
    fontSize: 30,
    fontWeight: "bold",
    color: "#FAA200",
    borderBottomColor: "#F8B02A",
  },
  iconAndName: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  nameText: {
    margin: 10,
    fontSize: 30,
    color: "#BA6612",
  },
  badgeContainer: {
    backgroundColor: "#fff",
    height: 250,
    width: 250,
    borderColor: "#BA6612",
    borderWidth: 5,
    borderRadius: 20,
    margin: 10,
    overflow: "hidden",
  },
  image: {
    height: 250,
    width: 250,
  },

  badgeRowContainer: {
    flexDirection: "row",
    overflow: "hidden",
  },
});
